

const testimonialsPath = '/obuchenie/otzyvy';

export {
  testimonialsPath,
};
